const translations: Record<string, string> = {
  pt: 'Esta área só está aberta para experiência desktop.',
  en: 'This area is exclusive for desktop users'
}

const Blocked: React.FC = () => {
  return (
    <div>
      <p>{translations[window.location.pathname.substring(1)] || translations['pt']}</p>
    </div>
  );
}

export default Blocked;
